export const ARKOSE = 'arkose';
export const RECAPTCHA = 'recaptcha';
export const botManagerType = [ARKOSE, RECAPTCHA] as const;

export const ARKOSE_SIGNUP_KEY = '98EFB87D-3554-499A-B9C9-4285EDF0DF57';
export const ARKOSE_LOGIN_KEY = '043FE28E-77E9-4A6F-9D15-927D0B035904';
export const ARKOSE_DEFAULT_KEY = ARKOSE_LOGIN_KEY;

export const LOGIN_RECAPTCHA_ID = 'recaptcha-login';
export const SIGNUP_RECAPTCHA_ID = 'recaptcha-signup';
export const LOGIN_REDESIGN_RECAPTCHA_ID = 'recaptcha-login-redesign';
export const SIGNUP_REDESIGN_RECAPTCHA_ID = 'recaptcha-signup-redesign';

export const RECAPTCHA_ACTIONS = {
  signup: 'signup',
  login: 'login',
  setPassword: 'set_password',
} as const;

export type RecaptchaAction = (typeof RECAPTCHA_ACTIONS)[keyof typeof RECAPTCHA_ACTIONS];
